import { CheckCircle2 } from "lucide-react";
import ServiceSectionShell from "./ServiceSectionShell";

const capabilities = [
  {
    title: "Managed Services",
    items: [
      "Proactive monitoring of onsite infrastructure",
      "24/7 help desk and applications support",
      "Hardware and software procurement",
      "Patch management and BDR",
    ],
  },
  {
    title: "Application Implementation",
    items: [
      "EHR, ERP, and clinical application selection",
      "Implementation planning and cutover",
      "Multi-skilled end-to-end project teams",
    ],
  },
  {
    title: "Infrastructure Support",
    items: [
      "Servers, network, storage, and security",
      "Wireless infrastructure services",
      "Application performance and uptime",
    ],
  },
  {
    title: "Applications Support",
    items: [
      "Onsite, offsite, and hybrid support models",
      "Seasoned healthcare application specialists",
      "Flexible coverage that follows the sun",
    ],
  },
  {
    title: "Data Analytics",
    items: [
      "Executive dashboards with operational KPIs",
      "Departmental reporting packages",
      "Tableau, Power BI, Crystal Reports",
    ],
  },
  {
    title: "Compliance Reporting",
    items: [
      "Quality, DSH, and Core Measures reporting",
      "Federal, state, and local agency filings",
      "Automated data pipelines across source systems",
    ],
  },
];

export default function HealthCare() {
  return (
    <ServiceSectionShell
      kicker="Healthcare IT Services"
      title="The IT services hospitals and clinics run on every day"
      lead="EHR support, infrastructure operations, applications, analytics, and compliance reporting — delivered by teams that have sat in your seat."
      tone="tint"
    >
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {capabilities.map((c) => (
          <div
            key={c.title}
            className="rounded-2xl border border-shark-200 bg-white p-5 shadow-sm transition-all hover:-translate-y-0.5 hover:border-complement-300 hover:shadow-[0_22px_64px_-44px_rgba(231,109,56,0.55)] sm:p-6"
          >
            <h4 className="text-[1rem] font-bold leading-snug text-shark-900">
              {c.title}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {c.items.map((item) => (
                <li
                  key={item}
                  className="flex items-start text-[0.86rem] leading-relaxed text-shark-600"
                >
                  <CheckCircle2 className="mr-2.5 mt-0.5 h-4 w-4 flex-shrink-0 text-complement-500" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </ServiceSectionShell>
  );
}
